import { ProgramIdentifier, Iata } from '@reward-platform/shared-schemas'
import { ServicesConfig } from './services-config'

export type MembersConfig = ServicesConfig & {
  programme?: ProgramIdentifier
}

export type PartnerMembersConfigs = Record<Iata, MembersConfig>

const partnerMemberConfigs: PartnerMembersConfigs = {
  BA: {
    apiKey: process.env.IAG_LOYALTY_API_KEY,
    baseUrl: process.env.IAG_LOYALTY_BASE_URL,
    programme: process.env.IAG_BA_LOYALTY_API_PROGRAMME as ProgramIdentifier,
  },
  EI: {
    apiKey: process.env.IAG_LOYALTY_API_KEY,
    baseUrl: process.env.IAG_LOYALTY_BASE_URL,
    programme: process.env.IAG_EI_LOYALTY_API_PROGRAMME as ProgramIdentifier,
  },
  VY: {},
  // IB: {
  //   apiKey: process.env.IAG_LOYALTY_API_KEY,
  //   baseUrl: process.env.IAG_LOYALTY_BASE_URL,
  //   programme: process.env.IAG_IB_LOYALTY_API_PROGRAMME as ProgramIdentifier,
  // },
}

export const getMembersConfigForPartner = (partner: Iata): MembersConfig => {
  return partnerMemberConfigs[partner]
}
